/**
 * @ngdoc Controller
 * @name InstallationSettingsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('InstallationSettingsController', InstallationSettingsController);

    /**
     * @constructor
     * @ngInject
     */
    function InstallationSettingsController($log) {
        $log.info('InstallationSettingsController');



    }

})();
